import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auctions-two-section',
  templateUrl: './auctions-two-section.component.html',
  styleUrls: ['./auctions-two-section.component.scss']
})
export class AuctionsTwoSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
